import { Component,
OnInit , OnDestroy, NgZone, ApplicationRef} from '@angular/core';
import {Product} from '../../../classes/product';
import {Flavours} from '../../../classes/flavour';
import {Filter} from '../../../classes/filter';
import {Cartitems} from '../../../classes/cartitems';
import {CartService} from '../../../services/cart.service';
import {ActivatedRoute, Router} from '@angular/router';
import { Http, Response } from '@angular/http';
import {CommonService} from '../../../services/common.service';
import {Brands} from '../../../classes/brands';
import {Lifestage} from '../../../classes/lifestages';
import {ProductsService} from '../../../services/products.service';
import {Pcategory} from '../../../classes/pcategory';
import {Inventory} from '../../../classes/inventory';
import {Cartitems2} from '../../../classes/cartitems';
import {Cityinventory} from '../../../classes/invcheck';
import { MatSnackBar, MatDialog } from '@angular/material';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/map';
import { MobilefilterpopupComponent } from '../../../common/mobilefilterpopup/mobilefilterpopup.component';
@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.css'],
})
export class SearchComponent implements OnInit , OnDestroy {
  checkingstock: number;
  check: any;
  timer: any;
 subscription: any;
 branddetail: any;
  uid: any;
  uname: any;
  uemail: any;
  umobile: any;
  totalitems: number;
  public brand: Brands[] ;
  flavour: Flavours[];
  lifestage: Lifestage[];
  public data = [] ;
  bcatagory: Brands[];
  inventory: Inventory[];
  ppinventory: Inventory[];
  data2: Cartitems2[];
  loading = false;
  city_id= 1;
  status: any = {};
  stock: any= {};
  category: any;
  searchid: any;
  status11: number;
  citems: number;
  public pcategory: Pcategory[] ;
  public tempuserid = 2;
  public tempusername = 'randomname';
  msg: any;
  action: any;
  cdata: any;
  cjson: any;
  tempcatagory: number;
  searchcategory: number;
  show= false;
  public filterarray = [];
  flavourfilterarray = [];
  lifestagefilterarray = [];
  temp: Product[];
  brand2 = [];
  flag = 0;
  cindex: number;
  prodname: string;
  prodsku: string;
  prodprice: number;
  discount: number;
  totaldiscount: number;
  quantity: number;
  payable: number;
  tax: number;
  p = 1;
  pid: number;
  stockflag = 0;
  cflag: number;
  cityinventory: Cityinventory[];
  product: Product[];
  qt= 1;
  searchdata: any;
  sortingorder: any;
  brandoption = [];
  dynamicbrandarray = [];
  dynamiclifearray = [];
  tempsearchdata = [];
  dynamicflavourarray = [];
  xcounter: any;
  found = 1;
  constructor(private route: ActivatedRoute, private router: Router,
     private cartService: CartService, private ref: ApplicationRef,
    private commonService: CommonService, public productsService: ProductsService,
     private snackbar: MatSnackBar, private zone: NgZone, public dialog: MatDialog) {
      window.scrollTo(0, 0);
      this.check = 0;
      this.commonService.setMenuFlag(1);
      this.route.params.subscribe(params => {
        this.productsService.productroute.next(1);
        this.branddetail = undefined;
        this.productsService.dynamicbrandpipe.next(0);
        this.category = params['cat'];
        const sid = params['id'];
        this.filterarray = [];
        this.flavourfilterarray = [];
        this.lifestagefilterarray = [];
        this.checkingstock = 0;
        this.getdata(sid);
      });
      const udata = this.commonService.getUserDataLocally();
      this.uid = udata.uid;
      this.uname = udata .uname;
      this.uemail = udata.uemail;
      this.umobile = udata.umobile;
      this.cartService.totalcartitems.subscribe(totalcartitems => {
      this.totalitems = totalcartitems
      });

      this.productsService.dynamicbrandpipevalue.subscribe(
        (x) => {
          if (x === 1) {
            this.checkingstock = 1;
            this.runzone();
          }
        });
    }

  ngOnInit() {
   this.timer = Observable.timer(2000, 5000);
  this.subscription = this.timer.subscribe(() => this.runzone());
    this.getProductInventory();
    this.commonService.getBrands()
        .subscribe(
          (brand: Brands[]) => {
            this.brand = brand;
           },
         );
     this.commonService.getFlavours()
        .subscribe(
          (flavour: Flavours[]) => this.flavour = flavour,
         );
     this.commonService.getLifestages()
        .subscribe(
          (lifestage: Lifestage[]) => this.lifestage = lifestage,
         );
   this.cartService.getUserCartItems(this.uid)
        .subscribe(
          (data2: Cartitems2[]) => {
           this.data2 = data2;
        });

  }

  runzone() {
    this.zone.run(() => {
      this.dynamicbrandarray = this.productsService.getDynamicbrandset();
      this.tempsearchdata = this.productsService.getDynamicbdataset();
      this.dynamiclifearray = this.productsService.getDynamiclifestageset();
      this.dynamicflavourarray = this.productsService.getDynamicflavourset();
    });
  }
  getProductInventory() {
    this.commonService.getCityInventoryDetails(this.city_id)
    .subscribe(
      (inventory: Inventory[]) => {
      this.inventory = inventory;
        this.checkStatus();
        this.checkingstock = 1;
    });
  }
  checkStatus() {
    for (let i = 0; i < this.inventory.length; i++) {
      this.status['id' + this.inventory[i].product_id] = this.inventory[i].status;
      this.stock['id' + this.inventory[i].product_id] = this.inventory[i].totalstock;
    }
  }
  filter(e, data) {
    if (e.target.checked) {
      this.filterarray.push(data);
    }
    if ( !e.target.checked) {
      for ( let i = 0 ; i < this.filterarray.length; i++) {
        if ( this.filterarray[i] === data ) {
          this.filterarray.splice(i , 1);
        }
      }
    }
  }
  flavourFilter(e , data) {
    if  (e.target.checked) {
      this.flavourfilterarray.push(data);
    }
    if ( !e.target.checked ) {
      for ( let i = 0; i < this.flavourfilterarray.length; i++) {
        if (this.flavourfilterarray[i] === data) {
          this.flavourfilterarray.splice(i, 1);
        }
     }
    }
  }
lifestageFilter(e , data) {
    if (e.target.checked) {
      this.lifestagefilterarray.push(data);
    }
    if (!e.target.checked) {
      for ( let i = 0; i < this.lifestagefilterarray.length; i++) {
        if (this.lifestagefilterarray[i] === data) {
          this.lifestagefilterarray.splice(i, 1);
        }
      }
    }
  }

getRandomInt() {
    return Math.floor(Math.random() * (20000 - 5 + 1)) + 5;
  }
  randomString() {
    const chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz';
    const string_length = 5;
    let randomstring = '';
    for (let i = 0; i < string_length; i++) {
      const rnum = Math.floor(Math.random() * chars.length);
      randomstring += chars.substring(rnum, rnum + 1);
    }
    return randomstring;
  }

  public addToCart(name: string, sku: string, price: number, id: number, splprice) {
    this.loading = true;
    this.stockflag = 0;
    this.checkStock(name, sku, price, id, splprice);
  }
  checkItems(sku) {
 if (this.data2.length > 0) {
      for (let i = 0; i < this.data2.length; i++) {
        if (this.data2[i].sku === this.prodsku) {
          this.flag = 1;
          this.cindex = i;
        }   
      }
    } else {
      this.flag = 0;
    }
  }
  checkStock(name, sku, price, id, splprice) {
    this.ppinventory = [];
    this.commonService.getInventoryDetails(id, this.city_id)
    .subscribe(
      (ppinventory: Inventory[]) => {
        this.ppinventory = ppinventory;
        this.controlStockFlag(name, sku, price, id, splprice);
      });
  }

  controlStockFlag(name, sku, price, id, splprice) {
    for (let p in this.ppinventory) {
      if ( this.ppinventory[p].product_id === id && this.ppinventory[p].status === 1){
        this.stockflag = 1 ;
      }
  }
if (this.stockflag === 1) {
      this.refreshcart(name, sku, price, id, splprice);
    }else {
      this.zone.run(() => {
        this.status['id' + id] = 0;
        this.stock['id' + id] = 0;
      });
      this.loading = false;
      this.msg = 'Item is Recently out of stock';
  }
}

  refreshcart(name: string, sku: string, price: number, id: number, splprice) {
    this.cartService.getUserCartItems(this.uid)
    .subscribe(
      (data2: Cartitems2[]) => {
        this.data2 = data2;
        this.addcart(name, sku, price, id, splprice);
      }
      );
  }

  addcart(name: string, sku: string, price: number, id: number, splprice) {
    this.pid = id;
    this.prodname = name;
    this.prodsku = sku;
    this.prodprice = price;
    if (splprice === 0) {
      this.discount = 0;
      this.totaldiscount = price;
      this.payable = price;
    } else {
      this.discount =  price - splprice;
      this.totaldiscount = splprice;
      this.payable = splprice;
    }
    this.checkItems(this.prodsku);
    this.tax = 0 ;
    if (this.flag === 0) {
      this.quantity = 1;
      this.cartService.createCart(this.pid, this.prodname, this.prodsku, this.prodprice,
         this.discount, this.totaldiscount, this.quantity, this.payable, this.tax, this.uid, this.uname)
      .subscribe(
        (data2: Cartitems2[]) => {
          this.data2 = data2;
          this.test();
        }
        );
    } else {
      this.quantity = this.data2[this.cindex].quantity + 1;
      this.payable = (this.data2[this.cindex].mrp - this.data2[this.cindex].discount)* this.quantity;
      this.cartService.updateCartIfPresent(this.data2[this.cindex].id, this.quantity, this.payable)
      .subscribe(
        (data2: Cartitems2[]) => {
          this.data2 = data2;
          this.test();
        }
        );
      }
  }
  removeFilter() {
    this.filterarray = [];
    this.flavourfilterarray = [];
    this.lifestagefilterarray = [];
  }
  openSnackBar() {
   this.snackbar.open(this.msg , this.action, {
     duration: 4000,
   });
 }
 brandCount(id) {
   let total = 0;
   for (let i = 0; i < this.data.length ; i++) {
     if (this.data[i].brand_id == id) {
       total = total + 1;
     }
   }
   return total;
 }
 tempbrandCount(id) {

  let total = 0;
  for (let i = 0; i < this.tempsearchdata.length ; i++) {
    if (this.tempsearchdata[i].brand_id === id) {
      total = total + 1;
    }
  }
  return total;
}
lifestageCount(id) {
  let total = 0;
  for (let i = 0; i < this.data.length ; i++) {
    if (this.data[i].lifestage_id == id) {
      total = total + 1;
    }
  }
  return total;
}
templifestageCount(id) {
  
    let total = 0;
    for (let i = 0; i < this.tempsearchdata.length ; i++) {
      if (this.tempsearchdata[i].lifestage_id === id) {
        total = total + 1;
      }
    }
    return total;
  }
  tempflavourCount(id) {
    let total = 0;
    for (let i = 0; i < this.tempsearchdata.length ; i++) {
      if (this.tempsearchdata[i].flavour_id === id) {
        total = total + 1;
      }
    }
    return total;
  }
  flavourCount(id) {
    let total = 0;
    for (let i = 0; i < this.data.length ; i++) {
      if (this.data[i].flavour_id == id) {
        total = total + 1;
      }
    }
    return total;
  }
 test() {
   this.loading = false;
  this.msg = 'Item is added';
  this.openSnackBar();
  this.totalitems = this.totalitems + 1;
  this.cartService.changeTotalCartItems(this.totalitems);
 }

  getdata(sid) {
    this.checkingstock = 1;
    this.searchid = undefined;
    this.check = 0;
    if (this.category === 'product') {
      if (sid !== 'all') {
        this.searchid = sid;

        this.data = [];
      }

      if (this.data.length === 0) {
        this.loading = true;
        this.productsService.getProducts()
        .subscribe(
          (x) => {
            this.loading = false;
            this.data = x;
            if (this.data && this.data.length > 0) {
              this.check = 1;
            }
          });
      }
    }
     if (this.category === 'brand') {
       this.check = 0;
      this.loading = true;
      this.productsService.getProductsByBrand(sid)
      .subscribe(
        (x) => {
          this.loading = false;
          this.data = x;
        })
        this.productsService.getbrandDetail(sid)
        .subscribe(
          (x) => {
            this.branddetail = x;
          }
        );
    }
    if (this.category === 'lifestage') {
      this.loading = true;
      if(sid == 5 || sid == 6 || sid == 7) {
        this.searchid = 'Puppy';
        this.productsService.getProductsByLifestagePuppy(sid)
      .subscribe(
        (x) => {
          this.loading = false;
          this.data = x;
        });
      }
      if(sid == 8) {
        this.searchid = 'Kitten';
        this.productsService.getFoodProductsByLifestageKitten(sid)
      .subscribe(
        (x) => {
          this.loading = false;
          this.data = x;
        });
      }
    }
  }
 ngOnDestroy() {
  this.commonService.setMenuFlag(0);
  this.subscription.unsubscribe();
 }
 isbrandCheck(id) {
  for (let i = 0; i < this.filterarray.length; i++) {
    if (this.filterarray[i] === id) {
      return true;
    }
  }
}
isFlavourCheck(id) {
  for (let i = 0; i < this.flavourfilterarray.length; i++) {
    if (this.flavourfilterarray[i] === id) {
      return true;
    }
  }
}
isLifeCheck(id) {
  for (let i = 0; i < this.lifestagefilterarray.length; i++) {
    if (this.lifestagefilterarray[i] === id) {
      return true;
    }
  }
}
windowScroll(){
  window.scrollTo(0, 0);
}

toggleMenu() {
  const dialogRef = this.dialog.open(MobilefilterpopupComponent, {
    width: '100%',
    height: '100%',
    data: {set: 2, data1: this.data, brand: this.brand, flavour: this.flavour, lifestage: this.lifestage,
    category: this.category, searchid: this.searchid, dynamicbrandarray: this.dynamicbrandarray,
    tempsearchdata: this.tempsearchdata, dynamiclifearray: this.dynamiclifearray,
    dynamicflavourarray: this.dynamicflavourarray}
  });
  dialogRef.afterClosed().subscribe(result => {
    if (result && result.length > 0 && result[0].no === 1) {
      this.filterarray = [];
      this.flavourfilterarray = [];
      this.lifestagefilterarray = [];
      this.filterarray.push(result[0].id);
    } else if (result && result.length > 0 && result[0].no === 2) {
      this.filterarray = [];
      this.flavourfilterarray = [];
      this.lifestagefilterarray = [];
      this.flavourfilterarray.push(result[0].id);
    } else if (result && result.length > 0 && result[0].no === 3) {
      this.filterarray = [];
      this.flavourfilterarray = [];
      this.lifestagefilterarray = [];
      this.lifestagefilterarray.push(result[0].id);
      } else {

   }
  });
}
}
